export const START_LOADING_PAGE_DATA = 'START_LOADING_PAGE_DATA';
export const STOP_LOADING_PAGE_DATA = 'STOP_LOADING_PAGE_DATA';





export const SET_HOME_PAGE_DATA = 'SET_HOME_PAGE_DATA';

export const SET_PROJECTS_LIST_DATA = 'projects/SET_PROJECTS_LIST_DATA';